import omit from 'lodash/fp/omit';
import { mapProps } from 'recompose';

const omitProps = keys => mapProps(props => omit(keys, props));

export default omitProps;
